"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var settings_1 = require("../../../shared/settings");
var browser_1 = require("@cian/telemetry/browser");
var httpAdapter_1 = require("../httpAdapter");
var request_1 = require("../../../shared/request");
exports.externalRequest = function (params) {
    var requestConfig = params.requestConfig, layersConfig = params.layersConfig, settings = params.settings;
    var requestLayersConfigs = settings_1.mergeLayersSettings(settings, layersConfig, browser_1.getTelemetry());
    var httpAdapter = new httpAdapter_1.HttpAdapter(requestConfig);
    var httpApiRequest = new request_1.RequestMonitor(__assign({ httpAdapter: httpAdapter, requestConfig: requestConfig }, requestLayersConfigs));
    return httpApiRequest.send();
};
//# sourceMappingURL=externalRequest.js.map